<script lang="ts">
import formFieldsInit from '../../utils/formFieldsInit.vue'
import FormLabel from './label.vue'

export default {
    name: 'YesnoField',
    components: { FormLabel },
    extends: formFieldsInit,
    props: {
        labelSidePosition: { type: Boolean, required: false },
        customLabel: { type: String, required: false, default: '' },
        customTrueText: { type: String, required: false, default: '' },
        customFalseText: { type: String, required: false, default: '' },
        checkbox: { type: Boolean, required: false },
        buttons: { type: Boolean, required: false },
        density: { type: String, required: false, default: 'default' },
        hideDetails: { type: Boolean, required: false, default: false },
        color: { type: String, required: false, default: undefined },
    },
    emits: ['updateData'],
    computed: {
        field() {
            return this.formService?.entity?.meta?.fields?.find(
                field => field.name === this.dataKey,
            )
        },
        isTag(): boolean {
            return !!this.field?.is_tag
        },
    },
    methods: {
        getOptionColor(title: string): string | undefined {
            return this.isTag ? this.field?.options?.find(option => option.title === title)?.color || '' : ''
        },
    },
    mounted() {
        if (this.value === null) {
            this.updateData(false)
        }
    },
}
</script>

<template>
    <FormLabel v-if="(data || injectedData || formService?.data) && (value !== undefined || rule)">
        <input
            v-if="!value"
            type="hidden"
            :name="customId ?? dataKey"
            value="false"
        >
        <v-checkbox
            v-if="rule && checkbox"
            :id="customId ?? dataKey"
            v-model="value"
            :name="customId ?? dataKey"
            :disabled="disabled"
            :hide-details="hideDetails && !getErrors()?.length"
            :density
            :color
            :error-messages="getErrors()"
            persistent-hint
            :hint="getInfo()"
            @update:model-value="$emit('updateData', $event); updateData($event); injectedValidation?.$touch()"
        >
            <template #label>
                <template v-if="injectedData && labelSidePosition">
                    <v-chip
                        v-if="isTag"
                        :variant="$config.public.chips_variant || 'tonal'"
                        :color="getOptionColor(`${value}`) || (value ? 'success' : 'error')"
                    >
                        {{ value ? (customTrueText || 'Oui') : (customFalseText || 'Non') }}
                    </v-chip>
                    <span v-else-if="formService">{{ value ? customTrueText || 'Oui' : customFalseText || 'Non' }}</span>
                </template>
                <legend v-else> {{ labelSidePosition ? $translate(`${translationName}.${dataKey}`) : customLabel }} </legend>
            </template>
        </v-checkbox>

        <template v-if="rule && buttons">
            <v-btn-toggle
                :id="customId ?? dataKey"
                :name="customId ?? dataKey"
                :disabled="disabled"
                class="border mb-2"
                v-model="value"
                divided
                @update:modelValue="injectedValidation?.$touch()"
            >
                <v-btn :class="value && 'bg-green'" @click.prevent="$emit('updateData', true)">{{customTrueText || 'Oui'}}</v-btn>
                <v-btn :class="!value && 'bg-danger'" @click.prevent="$emit('updateData', false)">{{ customFalseText || 'Non' }}</v-btn>
            </v-btn-toggle>

            <div class="v-messages ">
                <div class="v-messages__message ">
                    <template v-if="Array.isArray(getInfo())">{{ getInfo()?.join(', ') }}</template>
                    <template v-else>{{ getInfo() }}</template>
                    <div class="text-danger" v-if="Array.isArray(getErrors())"><b>{{ getErrors()?.join(', ') }}</b></div>
                </div>
            </div>

        </template>

        <v-switch
            v-else-if="rule && !checkbox && !buttons"
            :id="customId ?? dataKey"
            v-model="value"
            :name="customId ?? dataKey"
            :label="labelSidePosition ? $translate(`${translationName}.${dataKey}`) : customLabel"
            color="success"
            :disabled="disabled"
            persistent-hint
            :hint="getInfo()"
            :error-messages="getErrors()"
            @update:model-value="$emit('updateData', $event); updateData($event); injectedValidation?.$touch()"
        />
        <div v-else-if="isTag">
            <v-chip
                class="mt-1"
                :variant="$config.public.chips_variant || 'tonal'"
                :color="getOptionColor(`${value}`) || (value ? 'success' : 'error')"
            >
                {{ value ? (customTrueText || 'Oui') : (customFalseText || 'Non') }}
            </v-chip>
        </div>
        <div v-else-if="field && !rule">
            <span>{{ value ? customTrueText || 'Oui' : customFalseText || 'Non' }}</span>
        </div>
        <div v-else-if="!rule">
            <v-chip
                v-if="value"
                :variant="$config.public.chips_variant || 'tonal'"
                color="success"
            >
                {{ customTrueText ? customTrueText : 'Oui' }}
            </v-chip>
            <v-chip
                v-else
                :variant="$config.public.chips_variant || 'tonal'"
                color="error"
            >
                {{ customFalseText ? customFalseText : 'Non' }}
            </v-chip>
        </div>
    </FormLabel>
</template>
